import { render, staticRenderFns } from "./EdithApp.vue?vue&type=template&id=f7a91ae0&scoped=true"
import script from "./EdithApp.vue?vue&type=script&lang=js"
export * from "./EdithApp.vue?vue&type=script&lang=js"
import style0 from "./EdithApp.vue?vue&type=style&index=0&id=f7a91ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a91ae0",
  null
  
)

export default component.exports